<template lang="pug">
Page.developers
    .developers__top(
        slot="header"
    )
        h1.developers__title
            | Застройщики

        .developers__subheader
            SvInput.developers__search(
                v-model="search"
                placeholder="Введите название застройщика"
                color="gray"
                size="large"
            )

            SvButton.developers__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.developers__table(
        :headers="headers"
        :body="getList"
        @transfer="(e) => transfer(e.id)"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'Developers',

  data() {
    return {
      headers: [
        {
          title: 'Название',
          path: 'name',
          width: '25%',
        },
        {
          title: 'Символьный код',
          path: 'alias',
          width: '30%',
        },
        {
          title: 'Дата изменения',
          path: 'updated_at',
          width: '25%',
        },
        {
          title: 'Аквтивность',
          path: 'is_active',
          width: '20%',
        },
      ],
    };
  },

  beforeMount() {
    this.$store.dispatch('developer/getList');
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },

  computed: {
    ...mapGetters({
      getList: 'developer/getList',
    }),

    search: {
      get() {
        return this.$store.state.developer.search;
      },

      set(search) {
        this.$store.commit('developer/setSearch', search);
      },
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'developer-edit',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.developers__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.developers__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.developers__search {
    width: 47%;
    min-width: 280px;
}

.developers__table {
    margin-top: 30px;
}
</style>
